/**
 * WooCommerce Complete Order Event Handler for Algolia Analytics
 *
 * This module handles tracking when orders are completed and send on order received page.
 *
 * @module woo-order-complete-event
 */

import aa from 'search-insights';
import {debugLog} from '../utils/debug';

function extractPurchasedData() {

	// wpswapWCOrder is only localized on the order-received page; guard the
	// undeclared-variable case so this never throws a ReferenceError elsewhere.
	if (typeof wpswapWCOrder === 'undefined' || !wpswapWCOrder || !wpswapWCOrder.order) {
		return null;
	}

	const orderData = {
		currency: wpswapWCData.currency,
		items   : [],
		subtotal: 0,
		total   : 0
	};

	// Map through the order items localized from the completed order.
	orderData.items = Object.entries(wpswapWCOrder.order).map(([key, product]) => ({
		product_id  : product.id || product.product_id || 'none',
		quantity    : parseInt(product.quantity || 1),
		price       : parseFloat(product.price || 1),
		name        : product.name || product.title || '',
		sku         : product.sku || '',
		categories  : product.categories || [],
		variation_id: product.variation_id || null,
		total       : parseFloat(product.total || 0),
		subtotal    : parseFloat(product.subtotal || 0),
	}));

	// Derive the order value from the order line items rather than the cart,
	// which WooCommerce has already emptied by the time this page renders.
	orderData.subtotal = orderData.items.reduce((sum, item) => sum + (item.subtotal || 0), 0);
	orderData.total    = orderData.items.reduce((sum, item) => sum + (item.total || 0), 0);

	return orderData;
}

function formatEventData(purchasedData) {
	const eventData = {
		eventName : 'Purchase completed',
		eventType : 'conversion',
		index     : wpswapWCData.algolia_index_name_prefix + 'searchable_posts',
		objectIDs : purchasedData.items.map(item => item.product_id.toString() + '-0'),
		objectData: purchasedData.items.map(item => ({
			price   : item.price,
			quantity: item.quantity,
			name    : item.name
		})),
		currency  : wpswapWCData.currency,
		value     : purchasedData.total || 0
	};

	debugLog('Formatted Event Data:', eventData);
	return eventData;
}

function logCheckoutCompletedEvent() {
	if (!window.algolia?.insights_enabled) {
		return;
	}

	const purchasedData = extractPurchasedData();
	if (!purchasedData || !purchasedData.items || 0 === purchasedData.items.length) {
		return;
	}
	const eventData = formatEventData(purchasedData);

	if (eventData.objectIDs.length > 0) {
		debugLog('Sending event to Algolia:', eventData);
		aa('purchasedObjectIDs', eventData, {inferQueryID: true});
	} else {
		console.warn('No purchased items found to track');
	}
}

export function bindCheckoutCompleteEvent($) {
	$(document).ready(function () {
		logCheckoutCompletedEvent();
	});
}

